import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/settings')({
  component: () => <div style={{ padding: '24px' }}>Настройки — страница в разработке</div>,
})
